module.exports = __webpack_public_path__ + "static/media/kitap.c7876a20.jpg";